<template>
    <v-dialog v-model="dlgMultStatement" persistent width="800" max-width="dlgMultStatement">
        <v-card>
            <v-toolbar color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Statement by Range
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table :headers="headers" :items="statements" dense v-show="!print">
                    <template v-slot:item.Action="{item}">
                        <v-btn class="my-2 mr-2" icon color="primary" small @click="printStatement(item)"><v-icon>mdi-printer</v-icon></v-btn>
                    </template>
                </v-data-table>

                <v-progress-linear v-model="progress" height="25" class="my-5" v-show="print">
                    <strong>{{ Math.ceil(progress) }}%</strong>
                </v-progress-linear>
                <v-row justify="end">
                    
                <v-btn class="my-2 mr-2" color="primary" v-show="!print" small @click="printStatementOneByOne">Print All</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    props: ['statements', 'dlgMultStatement'],
    data: function () {
        return {
            headers: [
                { text: 'PayId', value: 'PayStId' },
                { text: 'Truck', value: 'Truck' },
                { text: 'OrderTotal', value: 'OrderTotal' },
                { text: 'HST', value: 'HST' },
                { text: 'SubTotal', value: 'SubTotal' },
                { text: 'Total', value: 'Total' },
                { text: 'Action', value: 'Action' },
            ],
            progress: 0,
            print: false,
        }
    },

    mounted() {
        console.log('here', this.statements);
    },
    methods: {
        printStatement: function(x){
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('payroll/print/' +  x.PayStId, {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute(
                            'download',
                            x.PayStId +
                            ' - ' +
                            x.Truck +
                            ' - ' +
                            moment(x.PayDate).format('ll') +
                            '.pdf'
                        );
                        document.body.appendChild(link);
                        link.click();
                        str.state.isLoading = false;

                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
        },
        printStatementOneByOne: async function () {
            this.print = true;
            this.progress = 0;
            var str = this.$store;
            const long = this.statements.length;
            const porcent = 100 / long;
            for (const x of this.statements) {
                await axios
                    .get('payroll/print/' +  x.PayStId, {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute(
                            'download',
                            x.PayStId +
                            ' - ' +
                            x.Truck +
                            ' - ' +
                            moment(x.PayDate).format('ll') +
                            '.pdf'
                        );
                        document.body.appendChild(link);
                        link.click();

                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
                    this.progress = porcent + this.progress;

            }
            this.$emit('close');
        }
    }
}
</script>